declare const I18n;
import learnerProgress from "../constants/progress-groups/learnerProgress.json";
import facilitatorProgress from "../constants/progress-groups/facilitatorProgress.json";

export type Phase = {
  key: string;
  title: string;
  subtitle: string;
  icon?: string;
  iconLink?: string;
  steps: string[];
  stepNumber?: number;
  totalSteps: number;
  completedSteps: number;
  completed: boolean;
};


function getProgressMap(userType: string) {
  if (userType === "learner") return learnerProgress;
  if (userType === "facilitator") return facilitatorProgress;
  return null;
}

function normalizePhase(phaseKey: string, phaseData: any) {
  if (Array.isArray(phaseData)) {
    // Backwards-compatible array form
    return {
      key: phaseKey,
      title: I18n.t(phaseKey),
      subtitle: "",
      iconLink: "",
      icon: "",
      steps: phaseData,
    };
  }

  const title =
    phaseData.titleKey ? I18n.t(phaseData.titleKey) : phaseData.title || phaseKey;
  const subtitle =
    phaseData.subtitleKey ? I18n.t(phaseData.subtitleKey) : phaseData.subtitle || "";

  return {
    key: phaseKey,
    title,
    subtitle,
    iconLink: phaseData.iconLink || "",
    icon: phaseData.icon || "",
    steps: phaseData.steps || [],
  };
}

export function getAllPhases(userType: string, completedSteps: string[] = []) {
  const progressMap = getProgressMap(userType);
  if (!progressMap) return [];

  return Object.entries(progressMap).map(([phaseKey, phaseData]) => {
    const phase = normalizePhase(phaseKey, phaseData);
    const totalSteps = phase.steps.length;
    const completedCount = phase.steps.filter((s: string) =>
      completedSteps.includes(s)
    ).length;
    return {
      ...phase,
      totalSteps,
      completedSteps: completedCount,
      completed: totalSteps > 0 && completedCount === totalSteps
    };
  });
}
